import axios from 'axios'
import { baseUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// 查询租户外部系统信息列表(分页)
export function systemPage(params) {
  const url = baseUrl + '/tenant/external/system/page'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('系统管理', '查询租户外部系统信息列表(分页)', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询租户外部系统信息列表(不分页)
export function systemList(params) {
  const url = baseUrl + '/tenant/external/system/list'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('系统管理', '查询租户外部系统信息列表(不分页)', res)
    }
    return Promise.resolve(res.data)
  })
}
// 更新租户外部系统信息
export function updatedSystem(params) {
  const url = baseUrl + '/tenant/external/system/update'

  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('系统管理', '更新租户外部系统信息', res)
    }
    return Promise.resolve(res.data)
  })
}
// 新增租户外部系统信息
export function systemAdd(params) {
  const url = baseUrl + '/tenant/external/system/add'
  return axios({
    method: 'put',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('系统管理', '新增租户外部系统信息', res)
    }
    return Promise.resolve(res.data)
  })
}

// 删除租户外部系统信息
export function deleteSystem(params) {
  const url = baseUrl + '/tenant/external/system/delete'
  return axios({
    method: 'delete',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('工作日志', '删除租户外部系统信息', res)
    }
    return Promise.resolve(res.data)
  })
}
